import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { Explore } from './pages/Explore';
import { ExploreBrands } from './pages/ExploreBrands';
import { RepublishedStories } from './pages/RepublishedStories';
import { Settings } from './pages/Settings';
import { Analytics } from './pages/Analytics';
export function AppRouter() {
  return <BrowserRouter data-id="element-1">
      <Layout data-id="element-2">
        <Routes data-id="element-3">
          <Route path="/" element={<Home data-id="element-5" />} data-id="element-4" />
          <Route path="/explore" element={<Explore data-id="element-7" />} data-id="element-6" />
          <Route path="/explore-brands" element={<ExploreBrands data-id="element-9" />} data-id="element-8" />
          <Route path="/republished" element={<RepublishedStories data-id="element-11" />} data-id="element-10" />
          <Route path="/analytics" element={<Analytics data-id="element-13" />} data-id="element-12" />
          <Route path="/settings" element={<Settings data-id="element-15" />} data-id="element-14" />
        </Routes>
      </Layout>
    </BrowserRouter>;
}